import type { ReactNode } from 'react';

import { Alert, AlertDescription } from '@parrot-software/design-system';
import { Info } from '@parrot-software/design-system/icons';
import { cn } from '@parrot-software/utils';

export type InfoNoteProps = {
  /**
   * The text. Pass a `<Trans>` when the sentence contains a `<strong>`: the markup survives because
   * this component renders its children as they are.
   */
  children: ReactNode;
  className?: string;
};

/**
 * The blue note the user form repeats: the box, the icon and the colors, never the text, so each
 * place can word its own note.
 *
 * @param {InfoNoteProps} props - Component properties
 */
export const InfoNote = ({ children, className }: InfoNoteProps) => (
  <Alert
    className={cn('border-info bg-bg-info font-sans text-info [&>svg]:text-info!', className)}
    data-testid="personnel-info-note"
  >
    <Info aria-hidden className="size-4" />
    <AlertDescription className="text-sm text-info">{children}</AlertDescription>
  </Alert>
);
